import React, { useState, useRef, useEffect } from "react";

interface InfoTooltipProps {
  text: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    <span className="relative inline-flex" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-4 h-4 rounded-full bg-gray-600 hover:bg-gray-500 text-gray-300 text-[10px] font-bold
          inline-flex items-center justify-center transition-colors ml-1 shrink-0"
        aria-label="More info"
      >
        ?
      </button>
      {open && (
        <div
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 z-50
          bg-gray-900 border border-gray-600 rounded-lg p-3 shadow-xl text-xs text-gray-300 leading-relaxed"
        >
          {text}
          <div
            className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0
            border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-gray-600"
          />
        </div>
      )}
    </span>
  );
};

export default InfoTooltip;
